module.exports = __webpack_public_path__ + "static/media/team-david.35b53fe7.png";